import React from 'react';
import { useNavigate } from 'react-router';
import Card from '@components/common/organisms/AppCard';
import Button from '@components/common/atoms/AppButton';
import Icon from '@components/common/atoms/Icon';

/**
 * Access Denied Component
 * Shows when user doesn't have permission to access a resource
 */
const AccessDenied: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <Card className="text-center p-12 max-w-lg">
        <div className="w-20 h-20 rounded-full bg-rose-50 dark:bg-rose-950/30 flex items-center justify-center mx-auto mb-6">
          <Icon name="ShieldAlert" size={40} className="text-rose-600 dark:text-rose-400" />
        </div>

        <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-3">
          Access Denied
        </h2>

        <p className="text-gray-600 dark:text-gray-400 mb-8 leading-relaxed">
          You don't have permission to access this resource.
          <br />
          Please contact your administrator if you believe this is an error.
        </p>

        <div className="flex gap-3 justify-center">
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            className="flex items-center gap-2"
          >
            <Icon name="ArrowLeft" size={18} />
            Go Back
          </Button>
          <Button
            onClick={() => navigate('/dashboard')}
            className="flex items-center gap-2"
          >
            <Icon name="Home" size={18} />
            Go to Dashboard
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default AccessDenied;
